const nodeIdByElement = new WeakMap()

export const registerNodeElement = (element, nodeId) => {
    if (!element || !nodeId) return
    nodeIdByElement.set(element, nodeId)
}

export const findNodeIdForElement = (element) => {
    let current = element
    while (current) {
        const nodeId = nodeIdByElement.get(current)
        if (nodeId) return nodeId
        current = current.parentElement
    }
    return null
}
